import { formatCellData } from './../pages/catalog/components/CatalogTable/utils/helper';
import { CellContext } from '@tanstack/react-table';
import { ColumnType, CatalogItemsHash } from '../pages/upload';

export const tableValueFormatter = ({
  column: { id },
  getValue,
}: CellContext<ColumnType, unknown>): string | number => {
  const value = getValue();
  return ['site', 'Material', 'ProcessID'].includes(id)
    ? formatCellData(value as CatalogItemsHash)
    : (value as string | number);
};
